import { stringifyFilter } from "colbi_web_ui/lib/utils";

export const mapCard = (json) => {
    const { ID, ReportName, Active } = json;
    return [
        [{ labels: ["customReportId"], value: ID, type: "string", basis: "20%" }],
        [
            {
                labels: ["reportName"],
                value: ReportName,
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                labels: ["reportActiveInProject"],
                value: Active,
                type: "is-active",
            },
        ],
        [{ labels: [], value: ["delete"], type: "user_actions" }],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        checked: json.selected,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: `/:locale(pt|en|lt|es|ro|fr)?/settings/custom_reports/?filter=${stringifyFilter([
                { column: "ReportName", filters: [{ value: `${json.ReportName}` }] },
            ])}`,
        },
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "20%",
        columnName: "RuleID",
        sortable: false,
    },
    {
        label: ["Report Name"],
        align: "left",
        basis: "50%",
        columnName: "ReportName",
        sortable: false,
    },
    {
        label: ["Report Active"],
        align: "center",
        columnName: "Active",
        sortable: false,
    },
    {
        label: ["checkbox"],
        align: "right",
    },
];

const packagesAssociationRules = {
    map: mapper,
    header,
};

export default packagesAssociationRules;
